// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "bundle." + {"194":"0b87a8e547577c165d7e","431":"e22e7fa722bcce589ab8","847":"291c503c2d4b0c2174b8","851":"f2fd3c013096e214c079","895":"64d891a44c95a1617153"}[chunkId] + ".js";
};